module.exports = __webpack_public_path__ + "img/bader.d78b5586.jpg";